document.addEventListener('DOMContentLoaded', function () {
  const findStockistsButton = document.querySelector('.stockistFinderBanner__button');
  const form = document.querySelector('.stockistFinderBanner__form');
  const pacInput = document.querySelector('#pac-input');
  const pacInputIcon = document.querySelector('.productStockist__contentFormInputIcon');
  const pacError = document.querySelector('.productStockist__contentError');
  const stockistFinderUrl = "/pages/stockists";

  let userPlace = null;
  let userLocation = null;

  function handleFindStockists() {
    clearErrorMessage();

    const currentLocation = userPlace ? {
      lat: userPlace.geometry.location.lat(),
      lng: userPlace.geometry.location.lng()
    } : userLocation;

    if (!currentLocation || (!currentLocation.lat && !currentLocation.lng)) {
      showErrorMessage('Please provide a valid location.');
      return;
    }

    const product = form.dataset.product;
    const productName = form.dataset.productName;
    const sku = form.dataset.sku;

    const productInformation = {
      name: productName || '', 
      url: product || '',
      place: pacInput.value,
      lat: currentLocation.lat,
      lng: currentLocation.lng,
      scu: sku || ''
    };
    const brandInformation = {
      place: pacInput.value,
      lat: currentLocation.lat,
      lng: currentLocation.lng,
    };

    if (product) {
      localStorage.setItem('productStockis', JSON.stringify(productInformation));
      localStorage.removeItem('brandStockis');
    } else {
      localStorage.removeItem('productStockis');
      localStorage.setItem('brandStockis', JSON.stringify(brandInformation));
    }

    location.href = `${document.location.origin}${stockistFinderUrl}`;
  }

  function clearErrorMessage() {
    if (pacError) {
      pacError.innerHTML = '';
      pacError.style.display = 'none'; 
    }
  }

  function showErrorMessage(msg) {
    if (pacError) {
      pacError.innerHTML = msg;
      pacError.style.display = 'block';
    }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    handleFindStockists();
  });

  const autocomplete = new google.maps.places.Autocomplete(pacInput, { componentRestrictions: {country: ['gb', 'ie']} });
  autocomplete.setFields(['address_components', 'geometry', 'name']);
  
  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    clearErrorMessage();

    if (!place.geometry) {
      showErrorMessage('Please select a valid place from the list.');
      userPlace = null;
      findStockistsButton.disabled = true;
    } else {
      userPlace = place;
      userLocation = null;
      findStockistsButton.disabled = false;
    }
  });

  pacInputIcon.addEventListener('click', function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        userPlace = null;
        pacInput.value = 'Current Location';
        findStockistsButton.disabled = false;
        clearErrorMessage();
      }, function () {
        showErrorMessage('Sorry, you need to enable location sharing.');
      });
    } else {
      showErrorMessage('Geolocation is not supported by your browser.');
    }
  });

  findStockistsButton.addEventListener('click', handleFindStockists);
});
